// extracted by mini-css-extract-plugin
export var image = "bv_b4";